import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import LatestBusinessOffers from './LatestBusinessOffers.vue';
import BusinessAndFleetSearch from './BusinessAndFleetSearch.vue';
import LocationDataLoader from '../../../modules/LocationDataLoader';
window.LocationDataLoader = new LocationDataLoader;

import LiveChatClass from '../../../live-chat/modules/live-chat-class';
import GoogleMapsLoaderClass from '../../../modules/GoogleMapsLoader';

if (typeof liveChatDisabled == 'undefined' || liveChatDisabled === false) {
    window.liveChatClass = new LiveChatClass;
    setTimeout(() => {
        liveChatClass.initLiveChat((typeof liveChatLocationId !== 'undefined') ? liveChatLocationId : false);
        liveChatClass.setCustomerType('New');
    }, 500);
}
// Create a global object for getting a new Google Maps instance
window.GoogleMapsLoader = new GoogleMapsLoaderClass;
// Handle detecting when Google Maps has finished loading
window.googleMapsLoaded = () => { GoogleMapsLoader.mapLoaded(); };
window.getMapIcon = getMapIcon;

setTimeout(() => {
    liveChatClass.initLiveChat((typeof liveChatLocationId !== 'undefined') ? liveChatLocationId : false);
}, 500);

Vue.use(Vuex);

window.document.addEventListener('DOMContentLoaded', () => {
    const businessAndFleetElement = document.querySelectorAll('.business-cms-vue-element');

    if (businessAndFleetElement.length > 0) {
        businessAndFleetElement.forEach(element => {
            try {
                initializeBusinessAndFleetApp(element);
            } catch (error) {
                console.error('Error initializing Business and Fleet app', error);
            }
        });
    }
});

export default function initializeBusinessAndFleetApp(businessAndFleet) {
    const store = new Vuex.Store({
        state: {
            loading: true,
            initialFilters: {},
            scopedFilters: {},
            activeFilters: {},
            sliderFilters: {},
        },
        actions: {
            getInitialFilters({commit, state}) {
                commit('enableLoadingState');

                return new Promise((resolve, reject) => {
                    axios.post('/ajax/business/options')
                        .then(response => {
                            commit('setInitialFilters', response.data);
                            commit('setScopedFilters', response.data);

                            resolve({data: response.data, instant: false});
                            commit('disableLoadingState');
                        })
                        .catch(error => {
                            console.error('Error getting vehicle data', error);
                            reject();
                            commit('disableLoadingState');
                        });
                });
            },
            getScopedFilters({commit, state}) {
                commit('enableLoadingState');

                return new Promise((resolve, reject) => {
                    axios.post('/ajax/business/options', state.activeFilters)
                        .then(response => {
                            commit('setScopedFilters', response.data);

                            resolve({data: response.data, instant: false});
                            commit('disableLoadingState');
                        })
                        .catch(error => {
                            console.error('Error getting scoped filters', error);
                            reject();
                            commit('disableLoadingState');
                        })
                });
            },
            updateSliderFilters({commit, state}, sliderFilters) {
                commit('setSliderFilters', sliderFilters);
            },
        },
        mutations: {
            setInitialFilters(state, initialFilters) {
                state.initialFilters = initialFilters;
            },
            setScopedFilters(state, scopedFilters) {
                state.scopedFilters = scopedFilters;
            },
            setActiveFilters(state, activeFilters) {
                state.activeFilters = activeFilters;

                Object.keys(state.activeFilters).forEach(key => setQueryParameter(key, state.activeFilters[key]));
            },
            setSliderFilters(state, sliderFilters) {
                state.sliderFilters = Object.assign({}, state.sliderFilters, sliderFilters);
            },
            enableLoadingState(state) {
                state.loading = true;
            },
            disableLoadingState(state) {
                state.loading = false;
            }
        }
    });

    const app = new Vue({
        el: businessAndFleet,
        data: {
            brand: 'randd',
        },
        store,
        components: {
            BusinessAndFleetSearch,
            LatestBusinessOffers,
        }
    });
}